// extracted by mini-css-extract-plugin
export default {"about":"AboutCompanySEO_about__r1YIs"};